import {
  fetchChats,
  updateChatLastMessage,
  updateChatWithMessages,
  updateChatData
} from "../actions";
import { baseUrl } from "./config";

//var database = firebase.firestore();
var database = {};

export const createConsult = async (payload, token, type = "video") => {
  /* 
	"customerId": "5e1e00a1a183ee06851fcb27",
	"professionalId": "5e272df8abda98098f31caa5",
	"type": "chat",
	"pricePerHour": 20.5
  */
  try {
    const response = await fetch(`${baseUrl}/consults/`, {
      method: "post",
      body: JSON.stringify({ ...payload, type }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();
    console.log(result);

    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

export const createChat = async (payload, token) => {
  return await createConsult(payload, token, "chat");
};

/* export const createChat = async (
  customer,
  professional,
  available_credits,
  price_per_hour,
  professional_name,
  customer_name,
  freeSample = false
) => {
  let max_available_minutes = Math.ceil(
    (available_credits * 60) / price_per_hour
  );
  if (freeSample) max_available_minutes = 5;

  return database
    .collection("chats")
    .doc(`${customer}+${professional}`)
    .get()
    .then(doc => {
      if (doc.exists) {
        //console.log('Já existe um chat');
        //atualizar status do chat para requested novamente...
        return database
          .collection("chats")
          .doc(`${customer}+${professional}`)
          .update({
            status: "requested",
            price_per_hour,
            max_available_minutes,
            available_credits,
            inactive_time: 0,
            credits_expired: false,
            free_sample: freeSample
          });
        //return {exists: true, message: 'Já existe um chat'}
      }
      //criar chat
      //console.log('criar chat');
      let members = {};
      members[customer] = true;
      members[professional] = true;
      return database
        .collection("chats")
        .doc(`${customer}+${professional}`)
        .set({
          members: members,
          status: "requested",
          professional,
          customer,
          price_per_hour,
          max_available_minutes,
          available_credits,
          inactive_time: 0,
          last_message: {},
          professional_name,
          customer_name,
          free_sample: freeSample
        });
    })
    .then(result => {
      if (result) {
        return result;
      }
      return { created: true };
    })
    .catch(error => {
      console.log(error);
      return { error: true };
    });
}; */

export const getChats = (userId, token) => async dispatch => {
  try {
    const response = await fetch(`${baseUrl}/chats/user/${userId}`, {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();
    console.log(result);
    dispatch(fetchChats(result));

    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

/* export const getChats = userId => dispatch => {
  const unsubscribe = database
    .collection("chats")
    .where(`members.${userId}`, "==", true)
    .onSnapshot(querySnapshot => {
      //console.log(querySnapshot);
      let list = [];
      querySnapshot.docChanges().forEach(change => {
        //if(change.type !== 'added') return;

        if (change.type === "modified") {
          //console.log(change.doc.data());

          //console.log(change.doc.data().last_message);
          //dispatch(updateChatLastMessage(change.doc.id,change.doc.data().last_message))
          dispatch(updateChatData(change.doc.id, change.doc.data()));
          return;
        }

        if (change.type === "added") {
          const data = change.doc.data();
          //console.log(data);
          let contactId = "";
          Object.keys(data.members).forEach(key => {
            if (key !== userId) {
              //console.log('quering for', key);
              contactId = key;
            }
          });

          list.push({
            ref: change.doc.id,
            data,
            contact: { id: contactId },
            messages: []
          });
        }
      });
      dispatch(fetchChats(list));
    });

  return unsubscribe;
}; */

/* export const getListWithContactsData = async chats => {
  let newList = [];

  const promises = chats.map(async chat => {
    let newChat = chat;
    if (!chat.contact.name) {
      const data = await getContactData(chat.contact.id);
      //console.log(data);
      newChat.contact.first_name = data.first_name;
      newChat.contact.avatar = data.avatar;
    }
    newList.push(newChat);
  });

  await Promise.all(promises);

  console.log(newList);
  return newList;
}; */

/* export const getContactData = async uid => {
  return database
    .collection("users")
    .doc(uid)
    .get()
    .then(doc => {
      //console.log(doc.data());

      if (doc.exists) {
        return doc.data();
      }
    })
    .catch(error => console.log(error));
}; */

export const getMessages = chatId => dispatch => {
  //console.log('*** getMessages ***');

  //let messages = [];
  const unsubscribe = database
    .collection("messages")
    .where("chat", "==", chatId)
    .orderBy("created", "desc")
    .limit(10)
    .onSnapshot(querySnapshot => {
      querySnapshot
        .docChanges()
        .reverse()
        .forEach(change => {
          switch (change.type) {
            case "added":
              //messages.push(change.doc.data());
              //console.log(change.doc.data());
              dispatch(updateChatWithMessages([change.doc.data()], chatId));
              break;

            default:
              break;
          }
        });
    });
  return unsubscribe;
};

export const createMessage = async (payload, token) => {
  try {
    const response = await fetch(`${baseUrl}/messages/`, {
      method: "post",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();

    return result;
  } catch (error) {
    return { error: true, message: "Não foi possível realizar esta ação" };
  }
};

/* export const createMessage = async ({ chat, from, text }) => {
  const payload = {
    chat,
    from,
    text,
    type: "text",
    created: new Date()
  };
  return database
    .collection("messages")
    .add(payload)
    .then(result => {
      //console.log(result);
      return database
        .collection("chats")
        .doc(chat)
        .update({
          last_message: payload
        });
    })
    .then(result => {
      console.log(result);
    })
    .catch(error => {
      console.log(error);
    });
}; */

export const createImageMessage = async (payload, token) => {
  try {
    const response = await fetch(`${baseUrl}/messages/`, {
      method: "post",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();
    console.log(result);

    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

/* export const createImageMessage = async ({ chat, from, image }) => {
  const payload = {
    chat,
    from,
    image,
    type: "image",
    created: new Date()
  };
  return database
    .collection("messages")
    .add(payload)
    .then(result => {
      //console.log(result);
      return database
        .collection("chats")
        .doc(chat)
        .update({
          last_message: payload
        });
    })
    .then(result => {
      console.log(result);
    })
    .catch(error => {
      console.log(error);
    });
}; */

export const activateChat = async (id, token) => {
  console.log("activateChat");
  //const beginTime = new Date();
  try {
    const response = await fetch(`${baseUrl}/consults/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ status: "active" }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();

    return result;
  } catch (error) {
    console.log(error);
  }
};

/* export const activateChat = async id => {
  return database
    .collection("chats")
    .doc(id)
    .update({
      status: "active",
      begin_time: new Date()
    })
    .then(result => {
      console.log(result);
    })
    .catch(error => {
      console.log(error);
    });
}; */

export const finalizeChat = async (consultId, token) => {
  try {
    const response = await fetch(`${baseUrl}/consults/${consultId}`, {
      method: "PATCH",
      body: JSON.stringify({ status: "finished" }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();

    return result;
  } catch (error) {
    console.log(error);
  }
};

export const updateConsultStatus = async (consultId, newStatus, token) => {
  try {
    const response = await fetch(`${baseUrl}/consults/${consultId}`, {
      method: "PATCH",
      body: JSON.stringify({ status: newStatus }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    if (!response.ok) {
      //console.warn(response);
      throw { message: "Não foi possível realizar esta ação" };
    }
    const result = await response.json();

    return result;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};

/* export const finalizeChat = async (id, creditsExpired = false) => {
  const end_time = new Date();
  return database
    .collection("chats")
    .doc(id)
    .update({
      status: "finished",
      end_time,
      credits_expired: creditsExpired
    })
    .then(result => {
      console.log(result);
    })
    .catch(error => {
      console.log(error);
    });
}; */

//function to leave, cancel chat
